import { render, staticRenderFns } from "./GameReminders.vue?vue&type=template&id=cec37cca&"
import script from "./GameReminders.vue?vue&type=script&lang=js&"
export * from "./GameReminders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports